/**
 * @file Fieldset component for change password link.
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { FieldsetBase } from '../fieldset-base/fieldset-base';
import { FieldsetProvider } from '../fieldset-provider';
import { ComponentRegistry } from '../../../core/component-registry';
import { SettingsService } from '../../../settings.service';
import { UserService } from '../../../user.service';
/**
 * Class for the change password link fieldset component. Only used in AccountComponent.
 *
 * @export
 * @class FieldsetPasswordlinkComponent
 * @extends {FieldsetBase}
 */
var FieldsetPasswordlinkComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FieldsetPasswordlinkComponent, _super);
    /**
     * Constructs a FieldsetPasswordlinkComponent.
     */
    function FieldsetPasswordlinkComponent(provider, settingsService, userService) {
        var _this = _super.call(this, provider) || this;
        _this.url = '';
        var passwordChangeUrl = settingsService.settings.frontend.oauth.passwordChangeUrl;
        _this.visible = passwordChangeUrl !== '' && passwordChangeUrl !== undefined;
        if (_this.visible) {
            _this.url = passwordChangeUrl + userService.user.Name;
        }
        return _this;
    }
    /**
     * Register component by the fieldset provider.
     */
    FieldsetPasswordlinkComponent.register = function () {
        ComponentRegistry.register('fieldset', 'passwordlink', FieldsetPasswordlinkComponent);
    };
    return FieldsetPasswordlinkComponent;
}(FieldsetBase));
export { FieldsetPasswordlinkComponent };
